<template >
  <div class="tab_padding mobile-p-top-0" ref="discussions_section">

    <div v-if="Object.keys(discussionsWithParent).length>0">
      <div v-for="(discussions, date) in discussionsWithParent" :key="date">
        <!-- Loop through the discussions within each title -->
        <issue-discussion-tab-row v-for="(discussion, index) in discussions" :key="index" :discussion="discussion"
                             :itemType="itemType" :itemId="itemId"
                                  :date="date" v-if="discussion.type=='issue'"
                             :logged-user-id="loggedUserId" @on-delete="displayDeleteConfirm(discussion,date)"></issue-discussion-tab-row>
      </div>

    </div>

    <div v-else class="inquiry-no-result no_result"><br/><h3 class="font-bold"><span class="fa fa-ban"></span> {{ emptyTxt }}</h3></div>
    <confirmation-popup ref="deleteDiscComment" id="delete-disc-comment" confirm-btn-text="Yes" cancel-btn-text="No">
      Are you sure you want to delete this comment?
    </confirmation-popup>
  </div>
</template>
<script >
import {getAllDiscussionData,deleteItemComment} from "@/modules/Booking/api/BookingViewTabs";
import {EventBus} from "@/events/event-bus";
import DiscussionTabRow from "./DiscussionTabRow.vue";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import IssueDiscussionTabRow from "./IssueDiscussionTabRow.vue";

export default {
  name: "IssueDiscussionTab",
  components: {IssueDiscussionTabRow, ConfirmationPopup, DiscussionTabRow},
  props :{
    value:{
      type: Array
    },
    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    bookingId: {
      type: Number
    },
  },
  data() {
    return {
      allDiscussions: [],
      emptyTxt: "",
      loggedUserId: 0
    };
  },
  computed: {
    discussionsWithParent() {
      const discussionsWithParent = {};

      for (const date in this.allDiscussions) {
        discussionsWithParent[date] = this.allDiscussions[date].map((discussion) => {
          // if (discussion.type === 'issue') {
            if (discussion.parent_id) {
              const parent = this.allDiscussions[date].find((d) => d.discussion_id === discussion.parent_id);
              discussion.parent = parent;
            }
            return discussion;
          // }
        });
      }

      return discussionsWithParent;
    },
  },
  methods: {
    addDiscussion(parentId){
      const capitalizedItemType = this.itemType.charAt(0).toUpperCase() + this.itemType.slice(1);
      const title = `${capitalizedItemType} Discussion`;
      const url = `/booking/discussion/${this.itemId}/send/${this.itemType}?parent_id=${parentId}`;
      window.popupi(title , url);
    },
    displayDeleteConfirm(discussion,key){
      let vm = this
      $("#delete-disc-comment").modal("show")
      vm.$refs.deleteDiscComment.$on("on-confirm",()=>{
        vm.deleteComment(discussion,key)
      })
    },
    deleteComment(discussion,key){
      let form = new FormData();
      form.set('discussion_id', discussion._id);
      form.set('type', discussion.type);
      form.set('id', discussion.booking_id);
      form.set('have_images', discussion.images.length>0);
      if(discussion.image_id)
        form.set('image_id', discussion.image_id);
      if(discussion.group_id)
        form.set('group_id', discussion.group_id);
      let vm =this
      deleteItemComment(form,1).then(response=>{
        const indexToDelete = vm.allDiscussions[key].findIndex(
            (item)=>item._id === discussion._id
        )
        if(indexToDelete!==-1){
          vm.allDiscussions[key].splice(indexToDelete,1)
        }
      })

    },
    loadDiscussionData(){
      let params = {};
      if(this.itemType=="booking"||this.itemType=="estimate")
        params.bookingId = this.bookingId?this.bookingId:this.itemId
      else if(this.itemType=="complaint")
        params.complaintId = this.itemId
      else if(this.itemType=="inquiry")
        params.inquiryId = this.itemId
      params.is_vue = 1

      getAllDiscussionData(params).then(response=>{
        this.allDiscussions = response.data.allDiscussions
        this.emptyTxt = response.data.emptyTxt
        this.loggedUserId = response.data.loggedUserId
        $(this.$refs.discussions_section).LoadingOverlay("hide")
        this.$emit('input', this.allDiscussions)
      })
    }
  },
  mounted(){
    $(this.$refs.discussions_section).LoadingOverlay("show")
    this.loadDiscussionData()
    EventBus.$on('refetchDiscussionsData', () => {
      this.loadDiscussionData()
    })
    EventBus.$on('onDeleteDiscusionFromAllTab', (discussion,key) => {
     this.displayDeleteConfirm(discussion,key)
    })
  }
}
</script>
<style scoped>
.tab_padding{
  padding-left: 0px;
  padding-right: 25px;
}
.new_item{
  display: flex;
  justify-content: flex-end; /* Align the contents to the right (for "New") */
  align-items: center; /* Vertically center the contents */
  cursor: pointer;
}
.new_item span{
  font-weight: 600;
  font-size: 16px;
}
.new_item span:first-child{
  padding-right: 5px;
}
.created-date{
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: rgb(98, 112, 124);
}
@media (max-width: 991px) {
  .mobile-p-top-0 {
    padding-top: 0px;
  }
  .mobile-p-bottom-0 {
    padding-bottom: 0px;
  }
}
</style>